import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-ui-standards',
    templateUrl: './ui-standards.component.html',
    styleUrls: ['./ui-standards.component.scss'],
    standalone: false,
})
export class UIStandardsComponent {
    // Demo Data
    demoTableData = [
        { id: 101, name: 'Sofia2 Flu + SARS', type: 'Assay', date: '2024-01-20', status: 'Active' },
        { id: 102, name: 'Savanna RVP4', type: 'Panel', date: '2024-01-21', status: 'Pending' },
        { id: 103, name: 'QuickVue Strep A', type: 'Test', date: '2024-01-22', status: 'Archived' },
        { id: 104, name: 'Triage BNP', type: 'Control', date: '2024-01-23', status: 'Active' },
        { id: 105, name: 'Sofia2 Lyme', type: 'Assay', date: '2024-01-24', status: 'Error' },
    ];

    displayedColumns: string[] = ['name', 'type', 'date', 'status', 'actions'];

    // Interactive Demo Properties
    isLoading = false;
    emailControl = new FormControl('', [Validators.required, Validators.email]);

    // Tab configuration with warning indicators
    tabs = [
        { label: 'Overview', icon: 'info', hasWarning: false },
        { label: 'Material vs PrimeNG', icon: 'compare_arrows', hasWarning: true },
        { label: 'Colors & Typography', icon: 'palette', hasWarning: false },
        { label: 'Buttons', icon: 'smart_button', hasWarning: true },
        { label: 'Forms & Inputs', icon: 'input', hasWarning: true },
        { label: 'Selection Controls', icon: 'check_box', hasWarning: true },
        { label: 'Tables & Grids', icon: 'table_chart', hasWarning: true },
        { label: 'Dialogs & Modals', icon: 'web_asset', hasWarning: true },
        { label: 'Feedback & Progress', icon: 'hourglass_empty', hasWarning: false },
        { label: 'Navigation & Layout', icon: 'view_quilt', hasWarning: false },
        { label: 'Custom Components', icon: 'extension', hasWarning: false },
    ];

    // Demo Methods
    saveExperiment() {
        this.isLoading = true;
        // Simulate API call
        setTimeout(() => {
            this.isLoading = false;
        }, 2000);
    }
}
